import { gql } from "@apollo/client";

// The company logo: one image per customer, shown in Company Settings and on
// the Trust Center. Uploads are REST (multipart); reading is GraphQL.
export const GET_COMPANY_LOGO = gql`
  query getCompanyLogo {
    getCompanyLogo {
      logoPath
    }
  }
`;

// logoPath is a path on the customer file CDN ("<customer id>/logo/<file>").
export const companyLogoUrl = (logoPath) =>
  logoPath
    ? `${(process.env.REACT_APP_CLOUDFRONT_URL || "").replace(/\/$/, "")}/${logoPath}`
    : null;

const request = async (method, { accessToken, idToken }, body) => {
  const baseUrl = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
  const response = await fetch(`${baseUrl}/api/company/logo`, {
    method,
    headers: { Authorization: `Bearer ${accessToken}`, id_token: idToken },
    body,
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result.message || "Could not save the logo. Try again.");
  }
  return result;
};

export const uploadCompanyLogo = (file, tokens) => {
  const formData = new FormData();
  formData.append("file", file);
  return request("POST", tokens, formData);
};

export const removeCompanyLogo = (tokens) => request("DELETE", tokens);
